import {
  PublishScreenshotsRequestBody,
  PublishScreenshotsRequestPath,
  PublishScreenshotsResponse,
} from '@eigtech/meetings-types'
import { contextualPost, useMutation } from '@eigtech/ui-shared-api'
import { meetingsBasePath } from './constants'

const publishScreenshots = ({
  entityId,
  startTime,
  ...payload
}: PublishScreenshotsRequestPath & PublishScreenshotsRequestBody) =>
  contextualPost<PublishScreenshotsResponse, PublishScreenshotsRequestBody>(
    `${meetingsBasePath}/meeting/screenshots/${entityId}/${startTime}`,
    payload,
    { responseType: 'none' }
  )

export const usePublishScreenshots = () =>
  useMutation({
    mutationFn: publishScreenshots,
  })
